import { render, staticRenderFns } from "./category-banner.vue?vue&type=template&id=005db560&"
import script from "./category-banner.vue?vue&type=script&lang=js&"
export * from "./category-banner.vue?vue&type=script&lang=js&"
import style0 from "./category-banner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('005db560')) {
      api.createRecord('005db560', component.options)
    } else {
      api.reload('005db560', component.options)
    }
    module.hot.accept("./category-banner.vue?vue&type=template&id=005db560&", function () {
      api.rerender('005db560', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/category-banners-slot/category-banner.vue"
export default component.exports